module.exports = __webpack_public_path__ + "static/media/tour_guide.3ac6753c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tour_guide.jpg
// module id = 50
// module chunks = 0